import supportModule from '../../support.module';

export default supportModule.component('supportCaseBanner', {
    template: require('./supportCaseBanner.component.html'),
    styles: require('./supportCaseBanner.component.css'),
    controller: controller
});

function controller($state, $window, asNotifier, textResources, urlConstants) {
    var vm = this;

    vm.$onInit = () => {
        vm.urlKC = urlConstants.knowledgeCenterUrl;
    };

    vm.goToCreateCase = () => {
        $state.go('support_createcase');
    };
}



// WEBPACK FOOTER //
// ./modules/support/components/support-case-banner/supportCaseBanner.component.js